import React, { useEffect, useMemo, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import { PageHeader } from '../../components/ui/PremiumUI';
import api from '../../services/api';
import { showConfirmation, showError, showSuccess } from '../../services/alert';
import './transportadoras.css';

const normalize = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export default function TransportadoraList() {
  const [lista, setLista] = useState([]);
  const [busca, setBusca] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const carregar = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/transportadoras');
      setLista(Array.isArray(data) ? data : []);
    } catch { showError('Não foi possível carregar as transportadoras.'); }
    finally { setLoading(false); }
  };

  useEffect(() => { carregar(); }, []);

  const remover = async (row) => {
    const confirmed = await showConfirmation({
      title: 'Excluir transportadora?',
      text: `${row.nome || 'Esta transportadora'} será removida do cadastro.`,
      confirmText: 'Sim, excluir', cancelText: 'Cancelar'
    });
    if (!confirmed) return;
    try {
      await api.delete(`/transportadoras/${row.id}`);
      showSuccess('Transportadora removida com sucesso.');
      carregar();
    } catch { showError('Não foi possível remover a transportadora.'); }
  };

  const filtradas = useMemo(() => {
    const termo = normalize(busca);
    return termo ? lista.filter((x) => normalize([x.nome, x.documento, x.inscricaoEstadual, x.municipio, x.uf].join(' ')).includes(termo)) : lista;
  }, [busca, lista]);

  const columns = [
    { name: 'Transportadora', selector: (r) => r.nome, sortable: true, grow: 2, cell: (r) => <div className="transportadora-name"><span className="transportadora-avatar"><i className="bi bi-truck" /></span><div><strong>{r.nome}</strong><small>{r.documento || 'Documento não informado'}</small></div></div> },
    { name: 'Inscrição Estadual', selector: (r) => r.inscricaoEstadual || '-', sortable: true, minWidth: '170px' },
    { name: 'Município', selector: (r) => r.municipio || '-', sortable: true, minWidth: '150px' },
    { name: 'UF', selector: (r) => r.uf || '-', sortable: true, width: '85px' },
    { name: 'Ações', width: '190px', right: true, cell: (r) => <div className="d-flex gap-2"><button type="button" className="btn btn-sm btn-outline-success" onClick={() => navigate(`/transportadoras/editar/${r.id}`)}><i className="bi bi-pencil me-1" />Editar</button><button type="button" className="btn btn-sm btn-outline-danger transportadora-icon-button" aria-label={`Excluir ${r.nome}`} onClick={() => remover(r)}><i className="bi bi-trash" /></button></div> }
  ];

  return <><Header /><main className="cm-page transportadoras-page">
    <PageHeader eyebrow="Cadastros" title="Transportadoras" description="Gerencie as empresas responsáveis pelo transporte e pela logística da operação." actions={<div className="d-flex flex-wrap gap-2"><button type="button" className="btn btn-outline-secondary" onClick={() => navigate('/menu')}><i className="bi bi-arrow-left me-2" />Voltar</button><button type="button" className="btn btn-success" onClick={() => navigate('/transportadoras/novo')}><i className="bi bi-plus-lg me-2" />Nova transportadora</button></div>} />
    <section className="cm-surface transportadoras-surface">
      <div className="transportadoras-toolbar"><div><h3>Transportadoras cadastradas</h3><p>{lista.length} {lista.length === 1 ? 'registro disponível' : 'registros disponíveis'}</p></div><div className="transportadoras-toolbar-actions"><label className="transportadoras-search"><i className="bi bi-search" /><input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar por nome, documento ou cidade" aria-label="Buscar transportadora" />{busca && <button type="button" onClick={() => setBusca('')} aria-label="Limpar busca"><i className="bi bi-x-lg" /></button>}</label><button type="button" className="btn btn-outline-secondary transportadora-refresh" onClick={carregar} disabled={loading}><i className={`bi bi-arrow-clockwise ${loading ? 'transportadora-spin' : ''}`} /><span>Atualizar</span></button></div></div>
      <div className="transportadoras-table"><DataTable columns={columns} data={filtradas} progressPending={loading} progressComponent={<div className="transportadoras-feedback"><span className="spinner-border spinner-border-sm" />Carregando transportadoras...</div>} pagination paginationPerPage={10} paginationRowsPerPageOptions={[10, 20, 30]} highlightOnHover responsive persistTableHead noDataComponent={<div className="transportadoras-empty"><i className="bi bi-truck" /><strong>Nenhuma transportadora encontrada</strong><span>{busca ? 'Tente ajustar os termos da busca.' : 'Cadastre a primeira transportadora para começar.'}</span></div>} /></div>
    </section>
  </main></>;
}
